import styled from 'styled-components'

export const InfoSchedule = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 8px;
  column-gap: 8px;
`
